import React, { memo,useEffect } from 'react';
import { Link } from 'react-router-dom';

import FooterCpn from '../../components/Footer/Footer-cpn';
import MenuCpn from '../../components/Menu/Menu-cpn';

import {Left,Right,Wrap} from './style';

export default memo(function Home() {

  useEffect(() => {
    document.getElementById('root').scrollTop = 0;
    document.title = '投资者服务';
  }, []);

  return (
    <div>

      <MenuCpn></MenuCpn>
      <Wrap>
        <Left>
          <img src={require('../../assets/img/1_08.png').default} alt=""/>
        </Left>
        <Right>
          <Link to="/Theme">
            <img src={require('../../assets/img/1_10.png').default} alt=""/>
          </Link>
          <Link to="/Answer">
            <img src={require('../../assets/img/1_12.png').default} alt=""/>
          </Link>
          <a href='http://www.sinochemintl.com/12732.html'>
            <img src={require('../../assets/img/1_14.png').default} alt=""/>
          </a>
        </Right>
      </Wrap>
      <FooterCpn bgColor={'#fff'}/>

    </div>
  )
})
